module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-4-57e7910816f8eb40158b554368a54170.jpeg";